import { render, staticRenderFns } from "./ActiveRoute.vue?vue&type=template&id=4165cf14&"
import script from "./ActiveRoute.vue?vue&type=script&lang=js&"
export * from "./ActiveRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports